import LongText from '@arivaa-react/components/longtext';
import { WebCrud } from '../../../containers/crud/webCrud';
import { Crud } from '../../../containers/crud/crud';
import { translate } from '../../../localization';

export default function ContactForm() {
  return (
    <WebCrud api="contact-form">
      <Crud.Header title="Contact Form">
        <Crud.Header.Actions>
          <Crud.Header.Actions.Refresh />
          <Crud.Header.Actions.Secondary>
            <Crud.Header.Actions.CsvImport />
            <Crud.Header.Actions.SampleCsvExport />
          </Crud.Header.Actions.Secondary>
        </Crud.Header.Actions>
      </Crud.Header>
      <Crud.Table
        columns={[
          {
            title: translate('support.message.label'),
            dataIndex: 'info',
            render: (info) => {
              return info
                ? Object.entries(info).map(([key, values]) => (
                    <>
                      <span>{key}:</span>{' '}
                      <LongText text={values} limit={25} title="Message" />
                    </>
                  ))
                : null;
            },
          },
        ]}
      >
        <Crud.Table.TableActions.Common />
        <Crud.Table.Header>
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}
